// extracted by mini-css-extract-plugin
export var cardIcon = "_61-4";
export var checkboxCard = "_61-0";
export var checkboxCardSelected = "_61-3";
export var disabled = "_61-1";
export var outerBorder = "_61-2";
export var spacerMedium = "_61-7";
export var spacerSmall = "_61-6";
export var spacerXsmall = "_61-5";